/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ScoringMethod } from "./ScoringMethod";

export interface Score {
  id: string;
  method: ScoringMethod;
  question_ids: string[];
  /** UCUM. `{score}` for a dimensionless total */
  unit: string;
}
